import { FC } from "react";
import { Outlet } from "react-router";

import Chatbot from "../chatbot/Chatbot";
import styles from "./EpostVerifisering.module.less";

export const VerificationPage: FC = () => {
  return (
    <>
      <section>
        <div className={styles.verificationContent}>
          <Outlet />
        </div>
      </section>
      <Chatbot />
    </>
  );
};

export default VerificationPage;
